import { ThresholdTypeOption } from './types';
import { COLORING_SCHEME } from 'utils/templates/scoringConfig';

// Threshold type options for dropdowns
export const THRESHOLD_TYPE_OPTIONS: ThresholdTypeOption[] = [
  { label: 'is equal to', value: 'eq', id: 'eq' },
  { label: 'is greater than', value: 'gt', id: 'gt' },
  { label: 'is greater than or equal to', value: 'gte', id: 'gte' },
  { label: 'is between', value: 'btw', id: 'btw' },
  { label: 'is less than', value: 'lt', id: 'lt' },
  { label: 'is less than or equal to', value: 'lte', id: 'lte' },
];

// Default color options from the coloring scheme
export const DEFAULT_COLORS = Object.keys(COLORING_SCHEME);

// Default rating labels for new thresholds
export const DEFAULT_RATINGS = ['Excellent', 'Good', 'Fair', 'Poor'];

// Default range values for 'between' threshold type
export const DEFAULT_RANGE: [number, number] = [0, 100];

// Default single value for non-range threshold types
export const DEFAULT_SINGLE_VALUE = '0';
